import { twMerge } from "tailwind-merge";
import { type ClassValue, clsx } from "clsx";
import { YearCnt } from "./types";
import { apiGet, apiPost } from "components/Common/Axios";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function roundToNearestFive(minutes: number): number {
  if (minutes < 0 || minutes > 59) {
    throw new Error("Input must be between 0 and 59.");
  }

  // Round the number to the nearest multiple of 5
  const rounded = Math.round(minutes / 5) * 5;

  // Ensure the result is within the 0 to 59 range
  return Math.min(Math.max(rounded, 0), 59);
}

export function xor(a: boolean, b: boolean): boolean {
  return (a && !b) || (!a && b);
}

export const popupZIndex = (popupLevel: number) => {
  return `z-[${10 + popupLevel * 10}]`;
};

export const nowRoundDateToNearestFiveMinutes = () => {
  // 새로운 Date 객체를 생성하여 원본을 수정하지 않도록 합니다.

  const roundedDate = new Date();

  // 초를 0으로 설정합니다.
  roundedDate.setSeconds(0, 0);

  // 현재 분을 가져옵니다.
  const minutes = roundedDate.getMinutes();

  // 분을 가장 가까운 5의 배수로 반올림합니다.
  const roundedMinutes = Math.round(minutes / 5) * 5;

  // 분이 60이 되는 경우, 시간을 하나 증가시키고 분을 0으로 설정합니다.
  if (roundedMinutes === 60) {
    roundedDate.setMinutes(0);
    roundedDate.setHours(roundedDate.getHours() + 1);
  } else {
    roundedDate.setMinutes(roundedMinutes);
  }

  return roundedDate;
};

export const roundDateToNearestFiveMinutes = (date: Date) => {
  // 새로운 Date 객체를 생성하여 원본을 수정하지 않도록 합니다.

  const roundedDate = new Date(date);

  // 초를 0으로 설정합니다.
  roundedDate.setSeconds(0, 0);

  // 현재 분을 가져옵니다.
  const minutes = roundedDate.getMinutes();

  // 분을 가장 가까운 5의 배수로 반올림합니다.
  const roundedMinutes = Math.round(minutes / 5) * 5;

  // 분이 60이 되는 경우, 시간을 하나 증가시키고 분을 0으로 설정합니다.
  if (roundedMinutes === 60) {
    roundedDate.setMinutes(0);
    roundedDate.setHours(roundedDate.getHours() + 1);
  } else {
    roundedDate.setMinutes(roundedMinutes);
  }

  return roundedDate;
};

export const formatKoreanDate = (date: string | Date) => {
  if (typeof date === "string") {
    date = new Date(date);
  }

  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  return `${year}-${month < 10 ? "0" + month.toString() : month}-${
    day < 10 ? "0" + day.toString() : day
  }`;
};

export const getYear = (date: string | Date) => {
  if (typeof date === "string") {
    date = new Date(date);
  }

  return date.getFullYear();
};

export const getMonth = (date: string | Date) => {
  if (typeof date === "string") {
    date = new Date(date);
  }

  return date.getMonth() + 1;
};

export const getCount = (yearCnts: YearCnt[], years: number[]) => {
  const cnts = yearCnts.filter((cnt) => years.includes(cnt.year));
  return cnts.reduce((acc, cur) => acc + cur.cnt, 0);
};

export const removeCommas = (numberString: string): string => {
  return numberString.replace(/[^0-9.]/g, "");
};

export const commaStringToNumber = (str: string) => {
  const nonCommaValue = removeCommas(str);
  const numValue = parseInt(nonCommaValue);
  if (isNaN(numValue)) {
    return 0;
  }
  return numValue;
};

export const getSchoolIdFromSchoolName = async (schoolName: string) => {
  const response = await apiPost("/school/search-one", { name: schoolName });
  if (response.error || !response.data) {
    console.error(
      "getSchoolIdFromSchoolName error",
      response.error,
      response.data
    );
    return 0;
  }
  return response.data.id;
};
